import { INTEGRATIONS_HOME } from "@/constants/routes";
import cn from "classnames";
import Image from "next/image";
import Link from "next/link";
import { FC } from "react";

import type { CaseStudyStatsIntegrationLogo } from "./CaseStudyStats.types";
import { Tooltip } from "./Tooltip";

const ALL_INTEGRATIONS_ICON_SRC =
  "https://front.com/webassets/icons/all-integrations.svg";

const KeyIntegrationLogoList: FC<{ logos: CaseStudyStatsIntegrationLogo[] }> = ({
  logos,
}) => {

  return (
    <ul className="flex flex-row flex-wrap items-center" role="list">
      {logos.map((logo, index) => {

        return (
          <li
            key={`${logo.src}-${index}`}
            className={cn(
              "group relative box-border flex size-[40px] shrink-0 items-center justify-center rounded-4",
              "border-2 border-solid border-white bg-gray-100",
              index > 0 && "-ml-[10px]",
            )}
            style={{ zIndex: index }}
          >

            <Link
              href={logo.href}
              className="flex size-full items-center justify-center rounded-4"
            >
              <Image
                src={logo.src}
                alt={logo.alt}
                width={28}
                height={28}
                className="size-[28px] object-contain"
              />
            </Link>

            {logo.showTooltip && (
              <Tooltip label={logo.label} />
            )}
          </li>
        );
      })}

      <li
        key="all-integrations"
        className={cn(
          "group relative flex size-[40px] items-center justify-center rounded-4",
          "border-2 border-solid border-white bg-gray-100",
          logos.length > 0 && "-ml-[10px]",
        )}
        style={{ zIndex: logos.length }}
      >
        <Link
          href={INTEGRATIONS_HOME}
          className="flex size-full items-center justify-center rounded-4"
          aria-label="View all integrations"
        >
          <Image
            src={ALL_INTEGRATIONS_ICON_SRC}
            alt=""
            width={16}
            height={16}
            className="size-2 object-contain"
          />
        </Link>
        <Tooltip label="View all" />
      </li>
    </ul>
  );
};

export { KeyIntegrationLogoList };
